import { render, staticRenderFns } from "./bottom-message.vue?vue&type=template&id=2cbf0164&scoped=true&"
import script from "./bottom-message.vue?vue&type=script&lang=js&"
export * from "./bottom-message.vue?vue&type=script&lang=js&"
import style0 from "./bottom-message.vue?vue&type=style&index=0&id=2cbf0164&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf0164",
  null
  
)

export default component.exports